<script>
import { mapState } from 'vuex'
import { formatDate } from '@lib/utils/format-date'
import NumberCard from './number-card'
import TopTenClicks from './top-ten-clicks'
import ClicksByOffer from './clicks-by-offer-type.vue'
import ClicksPerDay from './clicks-per-day.vue'

export default {
  name: 'Dashboard',
  page: {
    title: 'Dashboard',
  },
  components: {
    TopTenClicks,
    NumberCard,
    ClicksByOffer,
    ClicksPerDay,
  },
  data() {
    return {
      clickTypes: [
        {
          name: 'coupon',
          label: 'Coupon',
          fill: '#C98EE9',
        },
        {
          name: 'show',
          label: 'Show and Save',
          fill: '#2693F7',
        },
        {
          name: 'url',
          label: 'URL',
          fill: '#85A3EA',
        },
        {
          name: 'html',
          label: 'HTML',
          fill: '#FF9933',
        },
      ],
      periods: [
        { value: 'week', label: 'Last Week' },
        { value: 'month', label: 'Last Month' },
        { value: 'year', label: 'Last Year' },
      ],
      requesting: false,
    }
  },
  computed: {
    ...mapState('auth', ['profile']),
    numberCards() {
      const today = formatDate(new Date(), 'DD.MM.YYYY')

      return [
        {
          text: `Clicks as of ${today}`,
          img: '/dashboard/clicks.png',
          type: 'total_clicks',
        },
        {
          text: 'Offers',
          type: 'total_offers',
          img: '/dashboard/offers.png',
        },
      ]
    },
    userName() {
      const { profile } = this

      if (profile) {
        return `${profile.given_name} ${profile.family_name}`
      }

      return ''
    },
  },
}
</script>

<template>
  <main-layout :title="`Welcome ${userName}`">
    <template #header>
      <el-button
        type="primary"
        plain
        @click="$router.push({
          name: 'retailer-new'
        })"
      >
        + Add New Retailer
      </el-button>
    </template>
    <div :class="$style.dashboard">
      <el-row :gutter="30">
        <el-col
          :xs="24"
          :md="12"
        >
          <el-row>
            <clicks-by-offer
              :click-types="clickTypes"
              :periods="periods"
            />
          </el-row>
          <el-row>
            <clicks-per-day
              :click-types="clickTypes"
              :periods="periods"
            />
          </el-row>
        </el-col>
        <el-col
          :xs="24"
          :md="12"
        >
          <el-row :gutter="30">
            <el-col
              v-for="card in numberCards"
              :key="card.text"
              :xs="24"
              :md="12"
            >
              <number-card
                :card="card"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <top-ten-clicks />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main-layout>
</template>

<style lang="scss" module>
.dashboard {
  :global {
    .el-row {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-card__header {
      font-weight: 400;
    }
  }
}
</style>
